// GENERADO por tools/build-premium.ts — no editar a mano.
// Las 20 muestras oficiales por módulo que se practican sin cuenta.
// El resto vive en server/data/oficiales.json y lo sirve /api/questions/oficiales.
import type { Question } from '../types';

/** Total de muestras oficiales publicadas por la Comunidad de Madrid. */
export const OFICIALES_TOTAL = 187;

export const OPEN_QUESTIONS: Question[] = [
 {
  "id": "of-m1-001",
  "module": 1,
  "text": "Elija la respuesta que sea correcta de entre las siguientes:",
  "options": [
   "Voy a casa delante mi amigo para estudiar toda la tarde",
   "Voy a casa para mi amigo para estudiar toda la tarde",
   "Voy a casa mi amigo para estudiar toda la tarde",
   "Voy a casa de mi amigo para estudiar toda la tarde"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m1-002",
  "module": 1,
  "text": "¿Qué palabra tiene un significado similar a 'difícil'?",
  "options": [
   "Fácil",
   "Sencillo",
   "Simple",
   "Complicado"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m1-004",
  "module": 1,
  "text": "¿Qué palabra tiene un significado similar a 'tranquilo'?",
  "options": [
   "Nervioso",
   "Alterado",
   "Calmado",
   "Agitado"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m1-006",
  "module": 1,
  "text": "¿Qué palabra tiene un significado contrario a “fácil”?",
  "options": [
   "Sencillo",
   "Simple",
   "Difícil",
   "Cómodo"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m1-008",
  "module": 1,
  "text": "¿Qué palabra tiene un significado contrario a “caliente”?",
  "options": [
   "Abrasador",
   "Cálido",
   "Ardiente",
   "Frío"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m1-010",
  "module": 1,
  "text": "¿Qué pareja de palabras no significan lo mismo?",
  "options": [
   "Triste – Apenado",
   "Alto – Bajo",
   "Rápido – Presto",
   "Alegre – Festivo"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m1-011",
  "module": 1,
  "text": "¿Cuál es la forma correcta de entre las siguientes?",
  "options": [
   "La calle ser cortada por obras en la vía",
   "La calle está cortada por obras en la vía",
   "La calle tiene cortada por obras en la vía",
   "La cortada está calle por obras en la vía"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m1-013",
  "module": 1,
  "text": "Elija la respuesta que sea correcta frente a esta afirmación: “Cuando cocino para mis amigos”",
  "options": [
   "preparas platos deliciosos",
   "preparo platos deliciosos",
   "preparamos platos deliciosos",
   "preparan platos deliciosos"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m1-015",
  "module": 1,
  "text": "Elija la respuesta que sea correcta frente a esta afirmación: “Si hubiera sabido que necesitabas ayuda”",
  "options": [
   "te habría ofrecido mi apoyo inmediato",
   "te habrías ofrecido mi apoyo inmediato",
   "te ofreciste mi apoyo inmediato",
   "te hubieras ofrecido mi apoyo inmediato"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m1-017",
  "module": 1,
  "text": "¿Cuál de las siguientes definiciones corresponde a \"semáforo\"?",
  "options": [
   "Dispositivo luminoso que regula el paso de vehículos y peatones",
   "Luz que indica cambios de dirección",
   "Dispositivo que regula el flujo de aire en un motor",
   "Elemento que amortigua vibraciones"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m1-019",
  "module": 1,
  "text": "¿Cuál de las siguientes definiciones corresponde a \"elección\"?",
  "options": [
   "Técnica de cultivo de plantas en invernaderos",
   "Proceso de selección entre varias opciones o candidatos",
   "Método de conservación de alimentos mediante congelación",
   "Actividad recreativa que se realiza en la playa"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m1-020",
  "module": 1,
  "text": "...es a coche como piloto es a...",
  "options": [
   "Conductor - Avión",
   "Automóvil - Nave",
   "Viaje - Vuelo",
   "Carretera - Aeropuerto"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m1-022",
  "module": 1,
  "text": "...es a agua como sólido es a...",
  "options": [
   "Gaseoso – Vapor",
   "Bebida – Tierra",
   "Líquido – Hielo",
   "Mar – Gaseoso"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m1-024",
  "module": 1,
  "text": "Complete la frase con la opción correcta: \"El conductor __________ la ruta más rápida.\"",
  "options": [
   "conoce",
   "conoces",
   "conocí",
   "conocimos"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m1-026",
  "module": 1,
  "text": "Complete la frase con la opción correcta: \"El autobús __________ en perfectas condiciones.\"",
  "options": [
   "encontrarse",
   "se encuentra",
   "se encontraría",
   "se encontraste"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m1-028",
  "module": 1,
  "text": "¿Qué palabra no guarda relación con el resto?",
  "options": [
   "Manzana",
   "Pera",
   "Plátano",
   "Sudadera"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m1-029",
  "module": 1,
  "text": "Elija la respuesta correcta, entre las siguiente, respecto a esta afirmación: “Tener la mosca detrás de la oreja.”",
  "options": [
   "Tener una mosca",
   "Escuchar un zumbido",
   "Ser una mosca",
   "Sospechar algo"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m1-031",
  "module": 1,
  "text": "Elija la respuesta correcta, entre las siguiente, respecto a esta afirmación: “Me ha costado un riñón.”",
  "options": [
   "He tenido un problema",
   "He perdido algo",
   "Ha sido muy caro o difícil",
   "He hecho ejercicio"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m1-033",
  "module": 1,
  "text": "Dulce es a azúcar como salado es a",
  "options": [
   "Pimienta",
   "Sal",
   "Vinagre",
   "Aceite"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m1-035",
  "module": 1,
  "text": "Alto es a montaña como profundo es a:",
  "options": [
   "Río",
   "Lago",
   "Mar",
   "Valle"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m2-037",
  "module": 2,
  "text": "¿Cuál es la principal recomendación para utilizar una aplicación GPS de manera segura mientras se conduce?",
  "options": [
   "Ajustar la ruta durante el trayecto",
   "Mirar el GPS continuamente",
   "Ajustar la ruta antes de empezar a conducir",
   "Mirar el GPS cada vez que cambie la ruta"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m2-039",
  "module": 2,
  "text": "¿Qué debes hacer si el GPS deja de funcionar mientras conduces?",
  "options": [
   "Continuar conduciendo y esperar que se solucione solo",
   "Parar en un lugar seguro y reiniciar la aplicación",
   "Cambiar a otra aplicación mientras conduces",
   "Llamar a un amigo para pedir indicaciones"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m2-042",
  "module": 2,
  "text": "¿Qué debes hacer si el GPS te sugiere una ruta que no conoces?",
  "options": [
   "Continuar y confiar en el GPS",
   "Ignorar el GPS y seguir tu instinto",
   "Cambiar de aplicación GPS",
   "Parar en un lugar seguro y verificar la ruta"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m2-044",
  "module": 2,
  "text": "¿Por qué es recomendable usar un soporte magnético para el móvil al utilizar el GPS?",
  "options": [
   "Mejora la calidad de la señal",
   "Evita que el móvil se sobrecaliente",
   "Permite ajustar el móvil sin quitar la vista de la carretera",
   "Reduce el consumo de datos"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m2-047",
  "module": 2,
  "text": "¿Cómo eliminas una dirección guardada en el GPS?",
  "options": [
   "Desinstalando la aplicación del GPS",
   "Accediendo al menú de direcciones guardadas y seleccionando eliminar",
   "Reiniciando el GPS",
   "Cambiando de coche"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m2-049",
  "module": 2,
  "text": "¿Qué debes hacer para borrar el historial de búsqueda en el GPS?",
  "options": [
   "Formatear el GPS",
   "Acceder al historial de búsqueda y seleccionar borrar",
   "No se puede borrar el historial de búsqueda",
   "Reiniciar el coche"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m2-052",
  "module": 2,
  "text": "¿Cómo te avisa el GPS de un cruce peligroso?",
  "options": [
   "Con un cambio de color en el mapa",
   "Con una notificación de radar",
   "Mediante una alerta de cruce peligroso",
   "Con una vibración en el dispositivo"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m2-054",
  "module": 2,
  "text": "¿Cuál de estos parques es famoso por su Palacio de Cristal y su gran estanque?",
  "options": [
   "La Alhambra",
   "Parque Güell",
   "El Retiro",
   "Parque de María Luisa"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m2-057",
  "module": 2,
  "text": "¿En qué lugar de Madrid se encuentra el famoso \"Oso y el Madroño\"?",
  "options": [
   "Plaza Cataluña",
   "Puerta del Sol",
   "Plaza de la Constitución",
   "Plaza Mayor"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m2-059",
  "module": 2,
  "text": "¿En qué plaza de Madrid se encuentra la estatua ecuestre de Carlos III?",
  "options": [
   "Plaza Mayor",
   "Plaza de Oriente",
   "Puerta del Sol",
   "Plaza de España"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m2-062",
  "module": 2,
  "text": "¿Cuál de estos edificios en Madrid es un famoso centro de exposiciones y congresos?",
  "options": [
   "IFEMA",
   "Fira de Barcelona",
   "Ciudad de las Artes y las Ciencias",
   "Palacio Euskalduna"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m2-064",
  "module": 2,
  "text": "¿Cuál de estas calles es conocida por su vida nocturna y locales de música en vivo?",
  "options": [
   "Calle Betis",
   "Calle Huertas",
   "Calle Elvira",
   "Calle Estafeta"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m2-067",
  "module": 2,
  "text": "¿Qué calle en Madrid es conocida por su gran variedad de restaurantes?",
  "options": [
   "Calle Betis",
   "Calle Ponzano",
   "Calle Elvira",
   "Calle Larios"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m2-069",
  "module": 2,
  "text": "¿Qué avenida de Madrid conecta la Plaza de Castilla con el centro financiero?",
  "options": [
   "Paseo del Prado",
   "Paseo de la Castellana",
   "Calle de Alcalá",
   "Gran Vía"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m2-072",
  "module": 2,
  "text": "¿Cómo afecta la implementación de las Zonas de Bajas Emisiones (ZBE) a los conductores?",
  "options": [
   "Pueden usar cualquier vehículo sin restricciones",
   "Deben reducir el uso de transporte público",
   "Deben asegurarse de que sus vehículos cumplan con las normativas de emisiones",
   "Incrementan el uso de combustibles fósiles"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m2-074",
  "module": 2,
  "text": "¿Qué debe hacer un conductor si se encuentra con señalización de Zona de Bajas Emisiones (ZBE) y no está seguro de su significado?",
  "options": [
   "Continuar conduciendo sin reducir la velocidad",
   "Desactivar las luces del vehículo",
   "Consultar un mapa de ZBE o buscar información adicional",
   ": Ignorar la señalización"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m2-077",
  "module": 2,
  "text": "¿Qué debe hacer un conductor si ve una señal de prohibición de circulación para su tipo de vehículo en una Zona de Bajas Emisiones (ZBE)?",
  "options": [
   "Incrementar la velocidad para pasar rápidamente",
   "Desactivar las luces del vehículo",
   "Buscar una ruta alternativa y respetar la señal",
   "Ignorar la señal y continuar"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m2-079",
  "module": 2,
  "text": "¿Cuál es la función del distintivo medioambiental B?",
  "options": [
   "Identificar vehículos eléctricos",
   "Identificar vehículos de gasolina con normativa Euro 3",
   "Identificar vehículos de gas",
   "Identificar vehículos híbridos enchufables"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m2-082",
  "module": 2,
  "text": "¿Cuál es el beneficio de los distintivos medioambientales?",
  "options": [
   "Aumentan las emisiones de CO2",
   "Promueven el uso de vehículos antiguos",
   "Incrementan el tráfico",
   "Facilitan la identificación de vehículos menos contaminantes"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m2-084",
  "module": 2,
  "text": "¿Qué objetivo tiene el Real Decreto 1052/2022?",
  "options": [
   "Incrementar el tráfico vehicular",
   "Promover el uso de combustibles fósiles",
   "Eliminar las zonas peatonales",
   "Mejorar la calidad del aire y mitigar el cambio climático"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m3-087",
  "module": 3,
  "text": "¿Qué debemos hacer ante una mordedura de animal?",
  "options": [
   "Darle agua",
   "Lavar la herida con agua y jabón y cubrirla con un paño limpio",
   "Aplicar hielo directamente en la herida",
   "Darle un analgésico"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m3-089",
  "module": 3,
  "text": "¿Cuáles son las pautas de actuación en primeros auxilios?",
  "options": [
   "Correr, gritar y pedir ayuda",
   "Proteger, alertar y socorrer",
   "Esperar, observar y actuar",
   "Llamar, esperar y actuar"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m3-092",
  "module": 3,
  "text": "¿Cuándo se deben dar palmadas en la espalda a un niño?",
  "options": [
   "Cuando tiene fiebre",
   "Cuando está llorando",
   "Cuando está dormido",
   "Cuando se está atragantando y no puede respirar"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m3-094",
  "module": 3,
  "text": "En relación con la posición lateral de seguridad, ¿cuál de las siguientes afirmaciones es incorrecta?",
  "options": [
   "La posición lateral de seguridad ayuda a mantener la vía aérea abierta",
   "No debemos colocar a un herido inconsciente en posición lateral de seguridad sin la presencia de un médico",
   "Debemos colocar a un herido inconsciente que respira en posición lateral de seguridad",
   "La posición lateral de seguridad previene la caída de la lengua hacia atrás"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m3-097",
  "module": 3,
  "text": "¿Qué debemos hacer si un herido está inconsciente, pero respira?",
  "options": [
   "Colocarlo en posición lateral de seguridad",
   "Dejarlo en la posición en la que lo encontramos",
   "Darle agua para que recupere la consciencia",
   "Realizar maniobras de RCP"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m3-099",
  "module": 3,
  "text": "¿Qué debemos hacer si un herido tiene una amputación traumática?",
  "options": [
   "Darle algo de beber para calmarlo",
   "Colocarlo en posición lateral de seguridad",
   "Realizar maniobras de RCP",
   "Aplicar un torniquete por encima de la herida y conservar la parte amputada en frío"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m3-102",
  "module": 3,
  "text": "¿Cuál es la importancia del aprendizaje práctico en primeros auxilios?",
  "options": [
   "Solo es útil para profesionales de la salud",
   "No tiene relevancia en la formación de primeros auxilios",
   "Permite adquirir habilidades esenciales para actuar en situaciones de emergencia",
   "Es menos importante que el aprendizaje teórico"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m3-104",
  "module": 3,
  "text": "En el contexto de primeros auxilios, ¿cuál de las siguientes afirmaciones es incorrecta en relación con la protección de las víctimas?",
  "options": [
   "No debemos preocuparnos por la protección de las víctimas, solo personal especializado puede hacerlo",
   "Es importante proteger a las víctimas de posibles peligros adicionales",
   "La protección de las víctimas incluye asegurar la zona del accidente",
   "La protección de las víctimas es una prioridad para evitar más lesiones"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m3-107",
  "module": 3,
  "text": "¿Qué significa tener movilidad reducida?",
  "options": [
   "Tener dificultades para escuchar",
   "Tener dificultades para ver",
   "Tener dificultades para moverse o desplazarse",
   "Tener dificultades para hablar"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m3-109",
  "module": 3,
  "text": "¿Qué es la accesibilidad en el transporte público?",
  "options": [
   "La creación de rutas especiales para personas con discapacidad",
   "La adaptación de vehículos y servicios para ser utilizados por todas las personas, incluidas aquellas con discapacidades",
   "La reducción de tarifas para personas con discapacidad",
   "La instalación de ascensores en todas las estaciones"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m3-112",
  "module": 3,
  "text": "¿Qué se recomienda para la accesibilidad en el entorno urbano?",
  "options": [
   "Instalar más semáforos",
   "Proporcionar mapas de la ciudad",
   "Eliminar barreras arquitectónicas y proporcionar rutas accesibles",
   "Ofrecer transporte público gratuito"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m3-114",
  "module": 3,
  "text": "¿Por qué es importante mantener contacto visual con una persona con discapacidad auditiva?",
  "options": [
   "Facilita la lectura labial y la comunicación no verbal",
   "Es una señal de respeto",
   "Ayuda a mejorar la audición",
   "Es una norma de cortesía"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m3-117",
  "module": 3,
  "text": "¿Qué es un bastón guiador y cómo ayuda a las personas con discapacidad visual?",
  "options": [
   "Un dispositivo que mejora la audición",
   "Un sistema que facilita la movilidad",
   "Un dispositivo que ayuda a las personas con discapacidad visual a moverse de manera segura",
   "Un dispositivo que ayuda en la comunicación verbal"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m3-119",
  "module": 3,
  "text": "¿Cuál es la función principal de un guía que acompaña a una persona con discapacidad visual?",
  "options": [
   "Proporcionar compañía a la persona",
   "Ayudar a la persona con discapacidad auditiva",
   "Ofrecer apoyo emocional a la persona",
   "Asistir a la persona en su movilidad y orientación"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m3-122",
  "module": 3,
  "text": "¿Cuál es una característica esencial del comportamiento profesional en la atención al cliente?",
  "options": [
   "Hablar en voz alta",
   "Ignorar las quejas del cliente",
   "Mantener una actitud respetuosa y cortés",
   "Usar ropa informal"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m3-124",
  "module": 3,
  "text": "¿Cuál es una técnica clave de comunicación verbal para interactuar con los clientes?",
  "options": [
   "Usar jerga técnica",
   "Hablar en voz baja",
   "Hablar de manera clara y concisa",
   "Evitar el contacto visual"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m3-127",
  "module": 3,
  "text": "¿Qué debe hacer un conductor si se encuentra con un accidente en la carretera?",
  "options": [
   "Ignorar el accidente",
   "Detenerse en un lugar seguro y seguir los protocolos de emergencia",
   "Continuar conduciendo sin detenerse",
   "Culpar a otros conductores"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m3-129",
  "module": 3,
  "text": "¿Qué debe hacer un conductor en caso de incendio en el vehículo?",
  "options": [
   "Continuar conduciendo",
   "Ignorar el incendio",
   "Detener el vehículo en un lugar seguro y evacuar a los pasajeros",
   "Culpar a los pasajeros"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m3-132",
  "module": 3,
  "text": "¿Qué debe hacer un conductor para adaptar el servicio a personas con discapacidades cognitivas?",
  "options": [
   "Ignorar las necesidades del cliente",
   "Cobrar tarifas adicionales",
   "Evitar aceptar estos servicios",
   "Ser paciente y ofrecer explicaciones claras y sencillas"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m3-134",
  "module": 3,
  "text": "¿Qué debe hacer un conductor para manejar eficientemente las aplicaciones de VTC?",
  "options": [
   "Ignorar las funciones de la aplicación",
   "Usar solo las funciones básicas",
   "Familiarizarse con todas las funciones y características de la aplicación",
   "Desinstalar la aplicación"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-137",
  "module": 4,
  "text": "¿Qué tipo de prueba deben superar los conductores de vehículos de arrendamiento con conductor?",
  "options": [
   "Prueba de resistencia física",
   "Prueba de habilidades culinarias",
   "Prueba de conocimientos sobre manejo de dispositivos digitales con mapa de navegación, uso del castellano, y primeros auxilios, entre otros",
   "Prueba de conocimientos musicales"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-139",
  "module": 4,
  "text": "¿Qué necesitan tener las empresas titulares de autorizaciones de transporte para hacer contratos de transporte a distancia?",
  "options": [
   "Registro físico",
   "Notario",
   "Cámara de Comercio",
   "Dirección y firma electrónica"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m4-142",
  "module": 4,
  "text": "¿Quién da las autorizaciones de arrendamiento de vehículos con conductor?",
  "options": [
   "Ayuntamiento de Madrid",
   "Comunidad de Madrid",
   "Ministerio de Transporte",
   "Dirección General de Tráfico"
  ],
  "correct": 1,
  "official": true
 },
 {
  "id": "of-m4-144",
  "module": 4,
  "text": "¿Qué información se debe dar antes de empezar el servicio de arrendamiento de vehículo con conductor?",
  "options": [
   "Fecha de nacimiento del titular de la autorización",
   "Nombre del conductor",
   "Nombre y número de identificación fiscal del titular de la autorización",
   "Número de licencia del vehículo"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-147",
  "module": 4,
  "text": "¿Qué tipo de persona puede pedir la autorización de arrendamiento de vehículos con conductor según el Decreto 5/2024?",
  "options": [
   "Persona física o jurídica",
   "Únicamente personas solteras",
   "Únicamente personas casadas",
   "Solamente mayores de 18 años"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m4-149",
  "module": 4,
  "text": "¿El objetivo de los distintivos identificativos es mejorar la estética de los vehículos?",
  "options": [
   "Verdadero",
   "No se menciona en la normativa",
   "El objetivo de los distintivos es mejorar la identificación del conductor",
   "Falso"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m4-152",
  "module": 4,
  "text": "El incumplimiento de lo previsto en el Decreto 101/2016 será sancionado conforme a ______.",
  "options": [
   "el Código Penal",
   "la Ley de Seguridad Vial",
   "la Ley 16/1987, de 30 de julio, de Ordenación de los Transportes Terrestres",
   "el Reglamento de Tráfico"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-154",
  "module": 4,
  "text": "Los vehículos dedicados a la actividad de arrendamiento con conductor deben estar permanentemente identificados mediante ______.",
  "options": [
   "una pegatina blanca y amarilla",
   "un cartel en el parabrisas",
   "los distintivos previstos en el Anexo del Decreto 101/2016",
   "una placa en el techo"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-157",
  "module": 4,
  "text": "¿Qué se considera una infracción muy grave en relación con la captación de clientes?",
  "options": [
   "La captación de clientes en zonas rurales",
   "La captación de clientes en días festivos",
   "La circulación para búsqueda, recogida o captación de clientes que no hayan contratado previamente el servicio",
   "La captación de clientes a través de aplicaciones móviles"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-159",
  "module": 4,
  "text": "Completa la frase. La denegación de la autorización de arrendamiento de vehículos con conductor puede basarse en el valor límite anual de ______.",
  "options": [
   "CO2",
   "O3",
   "NO2 o PM2.5",
   "CH4"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-162",
  "module": 4,
  "text": "¿Cuándo se considera que un transporte es interurbano?",
  "options": [
   "Cuando el recorrido se realiza únicamente dentro de un término municipal",
   "Cuando el recorrido se realiza en zonas rurales",
   "Cuando el recorrido se realiza en zonas urbanas",
   "Cuando el recorrido rebase el territorio de un único término municipal"
  ],
  "correct": 3,
  "official": true
 },
 {
  "id": "of-m4-165",
  "module": 4,
  "text": "Completa la frase. La prestación de servicios mediante arrendamiento de vehículos con conductor deberá cumplir los requisitos relacionados con ______.",
  "options": [
   "tarifas",
   "publicidad",
   "conductores, vehículos y demás condiciones reglamentarias",
   "horarios"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-167",
  "module": 4,
  "text": "La prestación de servicios mediante arrendamiento de vehículos con conductor se realizará cumpliendo los requisitos reglamentarios en relación con los conductores y vehículos.",
  "options": [
   "Falso",
   "Verdadero, pero solo en áreas rurales",
   "Verdadero",
   "Falso, excepto en días festivos"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-170",
  "module": 4,
  "text": "¿Qué debe llevarse en el vehículo al iniciar un servicio de arrendamiento de vehículos con conductor?",
  "options": [
   "Los distintivos identificativos exigibles",
   "La publicidad",
   "Los datos del pasajero",
   "La matrícula del vehículo"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m4-172",
  "module": 4,
  "text": "¿Qué deben cumplir los titulares de autorizaciones de arrendamiento de vehículos con conductor en la Comunidad de Madrid?",
  "options": [
   "Los requisitos establecidos por la Unión Europea",
   "Los requisitos establecidos por el conductor",
   "Los requisitos establecidos reglamentariamente",
   "Los requisitos establecidos por la empresa titular de la autorización"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-175",
  "module": 4,
  "text": "¿Qué sucede si no se cumplen los requisitos establecidos reglamentariamente a la hora del otorgamiento de la autorización?",
  "options": [
   "Se concederá una autorización temporal",
   "Se solicitará un informe adicional",
   "Se denegará la autorización",
   "Se reducirá la tarifa"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-177",
  "module": 4,
  "text": "El órgano competente para el otorgamiento de autorizaciones de arrendamiento de vehículos con conductor en la Comunidad de Madrid es ______.",
  "options": [
   "la Comunidad de Madrid",
   "el Ayuntamiento",
   "el Ministerio de Transporte",
   "la Dirección General de Tráfico"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m4-180",
  "module": 4,
  "text": "¿Qué se debe presentar para la solicitud de convalidación del permiso de conductor de vehículos de arrendamiento con conductor?",
  "options": [
   "Una solicitud de convalidación por parte del interesado o su representante autorizado",
   "Un certificado de últimas voluntades",
   "Una foto de carné",
   "Un justificante médico"
  ],
  "correct": 0,
  "official": true
 },
 {
  "id": "of-m4-182",
  "module": 4,
  "text": "¿A qué está condicionada la obtención del permiso de conductor de vehículos de arrendamiento con conductor, entre otros requisitos?",
  "options": [
   "A la superación de una prueba física",
   "A la presentación de una declaración jurada",
   "Al pago de la tasa de expedición",
   "Al cumplimiento de requisitos ambientales"
  ],
  "correct": 2,
  "official": true
 },
 {
  "id": "of-m4-185",
  "module": 4,
  "text": "¿Qué debe hacer el titular del permiso de conductor de vehículos de arrendamiento con conductor transcurrido el periodo de vigencia de este?",
  "options": [
   "Devolver el permiso",
   "Cambiar de vehículo",
   "Informar a la policía",
   "Solicitar su renovación"
  ],
  "correct": 3,
  "official": true
 }
];
